import React from "react";
import { numberOrZero } from "../shared";
import "../DesignerPropertiesPanel.css";

const LayoutSection = ({ selectedObject, updateObjectFields }) => {
  return (
    <div className="dp-section">
      <h4 className="dp-section-title">Layout</h4>

      <div className="dp-grid-2">
        <div className="dp-field">
          <label className="dp-label">X</label>
          <input
            type="number"
            value={selectedObject.x}
            onChange={(e) =>
              updateObjectFields(selectedObject.id, {
                x: numberOrZero(e.target.value),
              })
            }
            className="dp-input"
          />
        </div>

        <div className="dp-field">
          <label className="dp-label">Y</label>
          <input
            type="number"
            value={selectedObject.y}
            onChange={(e) =>
              updateObjectFields(selectedObject.id, {
                y: numberOrZero(e.target.value),
              })
            }
            className="dp-input"
          />
        </div>

        <div className="dp-field">
          <label className="dp-label">Width</label>
          <input
            type="number"
            value={selectedObject.width}
            onChange={(e) =>
              updateObjectFields(selectedObject.id, {
                width: Math.max(1, numberOrZero(e.target.value)),
              })
            }
            className="dp-input"
          />
        </div>

        <div className="dp-field">
          <label className="dp-label">Height</label>
          <input
            type="number"
            value={selectedObject.height}
            onChange={(e) =>
              updateObjectFields(selectedObject.id, {
                height: Math.max(1, numberOrZero(e.target.value)),
              })
            }
            className="dp-input"
          />
        </div>

        <div className="dp-field">
          <label className="dp-label">Rotation</label>
          <input
            type="number"
            value={selectedObject.rotation || 0}
            onChange={(e) =>
              updateObjectFields(selectedObject.id, {
                rotation: numberOrZero(e.target.value),
              })
            }
            className="dp-input"
          />
        </div>

        <div className="dp-field">
          <label className="dp-label">Z Index</label>
          <input
            type="number"
            value={selectedObject.z_index || 0}
            onChange={(e) =>
              updateObjectFields(selectedObject.id, {
                z_index: numberOrZero(e.target.value),
              })
            }
            className="dp-input"
          />
        </div>
      </div>
    </div>
  );
};

export default LayoutSection;